<div
    id="{{id}}"
    [ngStyle]="{position: 'relative', width: '100%'}"
>
    @switch (key) {
        @case ('text')
        @case ('analysis') {
            <agpr-text-display
                [data]="data"
            ></agpr-text-display>
        }
        @case ('title') {
            <agpr-title-display
                [data]="data"
            ></agpr-title-display>
        }
        @case ('image') {
            <agpr-image-display
                [includeEmptySections]="includeEmptySections"
                [displayAutomateImagePlaceholder]="displayAutomateImagePlaceholder"
                [showErrors]="showErrors"
                [isPublished]="isPublished"
                [data]="data"
            ></agpr-image-display>
        }
        @case ('date') {
            <agpr-date-display
                [data]="data"
                [referenceDate]="referenceDate"
                [showRecurrenceDateRangePlaceholder]="showRecurrenceDateRangePlaceholder"
            ></agpr-date-display>
        }
        @case ('curated') {
            @if (includeEmptySections || data.mentions.length > 0) {
                <agpr-mention-grid-display
                    [id]="id"
                    [data]="data"
                    (viewAllMentionsClicked)="viewAllMentions()"
                ></agpr-mention-grid-display>
            }
        }
        @case ('curated_mention_list') {
            @if (includeEmptySections || data.mentions.length > 0) {
                <agpr-mention-grid-display
                    [id]="id"
                    [data]="data"
                    (viewAllMentionsClicked)="viewAllMentions()"
                ></agpr-mention-grid-display>
            }
        }
        @case ('automatic') {
            @if (includeEmptySections || data.mentions.length > 0) {
                <agpr-mention-grid-display
                    [id]="id"
                    [data]="data"
                    (viewAllMentionsClicked)="viewAllMentions()"
                ></agpr-mention-grid-display>
            }
        }
        @case ('automatic_mention_list') {
            @if (includeEmptySections || data.mentions.length > 0) {
                <agpr-mention-grid-display
                    [id]="id"
                    [data]="data"
                    (viewAllMentionsClicked)="viewAllMentions()"
                ></agpr-mention-grid-display>
            }
        }
        @case ('alert_mentions') {
            alert mentions placeholder
        }
        @case ('table_of_content') {
            <agpr-table-of-contents-display
                [data]="data"
            ></agpr-table-of-contents-display>
        }
        @case ('divider') {
            <agpr-divider-display
                [data]="data"
            ></agpr-divider-display>
        }
        <!-- The key for social links isn’t always consistent, so we handle both link and links -->
        @case ('link') {
            <agpr-social-links-display
                [data]="data"
            ></agpr-social-links-display>
        }
        @case ('links') {
            <agpr-social-links-display
                [data]="data"
            ></agpr-social-links-display>
        }
        @default {
            <!-- should never run into here -->
            <div>Unknown component type</div>
        }
    }
</div>
